module.exports = __webpack_public_path__ + "static/img/celoscope-detail-2.572e8ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-2.jpg
// module id = 7aaR
// module chunks = 52